<template name="scriptList">
	<div>
    <el-tabs @tab-click="handleClick">
      <el-tab-pane label="新建脚本" name="0"></el-tab-pane>
      <el-tab-pane label="已发布脚本" name="1"></el-tab-pane>
      <el-tab-pane label="未发布脚本" name="2"></el-tab-pane>
    </el-tabs>

		<!-- 新建脚本 -->
		<create-new-script v-if="tab_index==0" :companyId="companyId"
			@add="add"/>

		<!-- 已发布的脚本 从二级项目管理的发布页面迁移 -->
		<launch-script-list v-if="tab_index==1" :companyId="companyId" @design="autoPickOther"
			v-on="$listeners"/>

		<!-- 未发布脚本 -->
		<check-script-list v-if="tab_index==2" :companyId="companyId"
			@delete="$emit('delete')" @design="autoPick" v-on="$listeners"/>
	</div>
</template>
<script>
	import LaunchScriptList from "./ScriptListComponents/LaunchScriptList"
	import CheckScriptList from "./ScriptListComponents/CheckScriptList"
	import CreateNewScript from "./ScriptListComponents/CreateNewScript"
	export default {
		name: "scriptList",
		components: {
			LaunchScriptList,
			CheckScriptList,
			CreateNewScript,
		},
		data() {
			return {
				userId: '',
				show: 1,
				tab_index: 0,
			}
		},
		//此处定义传入的数据
		props: {
			companyId: Number,
		},
		mounted: function() {
      this.userId = window.localStorage.getItem('userid');
		},
		methods: {
      handleClick(e) {
        this.tab_index = Number.parseInt(e.index);
      },
			//新建页面的事件抛出
			add(startParam) {
				this.$emit('add', startParam)
			},
      autoPick(item){
        this.$emit('autoPick',item)
      },
      autoPickOther(item){
        this.$emit('autoPickOther',item)
      }
		},

	}
</script>
<style>
</style>
